import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import br from './locale/br'
import es from './locale/es'
// Only the signup v2 onboarding is translated to English / Portuguese for now; anything else falls
// back to Spanish.
import signupV2En from './locale/signupV2.en'
import signupV2Pt from './locale/signupV2.pt'

const resources = {
  es: { translation: es },
  br: { translation: br },
  en: { translation: signupV2En },
  pt: { translation: signupV2Pt }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;